import { Button } from "@mantine/core"
import { useTranslation } from "react-i18next"

// Series colours and axis styling shared with the overview chart (parts/SalesChartCard).
export const SERIES = {
  current : "var(--mantine-color-dark-8)",
  previous: "var(--mantine-color-gray-5)",
  accent  : "var(--mantine-color-brand-6)",
}

export const AXIS_LABEL = { color: "var(--mantine-color-gray-7)", fontSize: "14px" }
export const GRID_LINE = "var(--mantine-color-gray-2)"
export const AXIS_LINE = "var(--mantine-color-gray-3)"

export const TOOLTIP = {
  shared         : true,
  backgroundColor: "var(--mantine-color-white)",
  borderColor    : "var(--mantine-color-gray-3)",
  borderRadius   : 8,
  style          : { fontSize: "14px" },
}

export const LEGEND = {
  align        : "left" as const,
  verticalAlign: "top" as const,
  itemStyle    : { fontSize: "14px", fontWeight: "500", color: "var(--mantine-color-gray-7)" },
}

export function YoYToggle({ active, onToggle }: { active: boolean; onToggle: () => void }) {
  const { t } = useTranslation(["dashboard"])
  return (
    <Button
      variant={active ? "filled" : "default"}
      color="dark"
      onClick={onToggle}
      aria-pressed={active}
    >
      {t("analytics.toggleYoY", { defaultValue: "Өмнөх жил" })}
    </Button>
  )
}
